import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import maintenance from 'resources/images/maintenance.png'
import AppBar from 'page/Login/component/AppBar'
import { useMutation } from '@tanstack/react-query'
import { information } from 'service/infoService'
import { useLangStore } from 'store/authAtom'

const Maintenance = () => {
    const {
        i18n: { language },
        t,
    } = useTranslation()
    const [windowHeight, setWindowHeight] = useState(window.innerHeight)
    const lang = useLangStore((state) => state.lang)

    const updateWindowHeight = () => {
        const newWindowHeight = window.innerHeight
        setWindowHeight(newWindowHeight)
    }

    const checkMaintenance = useMutation({
        mutationFn: information.checkMaintenance,
        onSuccess: (res) => {
            if (res.websiteMaintenance === 0) {
                window.location.href = `${process.env.REACT_APP_WEBSITE}?lang=${lang}`
            }
        },
        onError: (e) => console.log(e),
    })

    useEffect(() => {
        window.addEventListener('resize', updateWindowHeight)
        checkMaintenance.mutate()
        return () => {
            window.removeEventListener('resize', updateWindowHeight)
        }
    }, [])

    return (
        <div
            className={`flex flex-col text-body1 ${language === 'en_US' ? 'font-kt-en' : 'font-kt-zh'}`}
            id='main-container'
            style={{ height: windowHeight }}
        >
            <header className='sticky top-0 z-50' id='main-header'>
                <AppBar isMaintenance={true} />
            </header>
            <div className='w-full flex-1 flex items-center justify-center'>
                <div className='sm:mx-auto mx-5 text-secondary-midnightBlue text-center md:max-w-[504px]'>
                    <img src={maintenance} alt='' className='w-[120px] h-[120px] mx-auto mb-8' />
                    <div className='text-h3 pb-4'>{t('maintenance.title')}</div>
                    <div className='text-body1'>{t('maintenance.desc')}</div>
                </div>
            </div>
        </div>
    )
}

export default Maintenance
